module.exports = __webpack_public_path__ + "img/nav-pic.8ae7c52c.png";